import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getModel_documents = createAsyncThunk(
  "FormsAndTemplates/getModel_documents",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/model_documents`,

          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addModel_documents = createAsyncThunk(
  "FormsAndTemplates/addModel_documents",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/model_documents`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateModel_documents = createAsyncThunk(
  "FormsAndTemplates/updateModel_documents",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/model_documents/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const deleteModel_documents = createAsyncThunk(
  "FormsAndTemplates/deleteModel_documents",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/model_documents/${id}`,

          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getAllIssueTasks = createAsyncThunk(
  "Issue/getAllIssueTasks",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/tasks`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
          params: data
            ? {
                is_company: true,
                ...data,
              }
            : {
                is_company: true,
              },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddAllIssueTasks = createAsyncThunk(
  "Issue/AddAllIssueTasks",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/company/tasks`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateAllIssueTasks = createAsyncThunk(
  "Issue/updateAllIssueTasks",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/tasks/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteAllIssueTasks = createAsyncThunk(
  "Issue/DeleteAllIssueTasks",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(`${process.env.REACT_APP_BACKEND_API}api/company/tasks/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getAllIssueTasksAdds = createAsyncThunk(
  "Issue/getAllIssueTasksAdds",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/task_adds`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
          params: data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddAllIssueTasksAdds = createAsyncThunk(
  "Issue/AddAllIssueTasksAdds",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/task_adds`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateAllIssueTasksAdds = createAsyncThunk(
  "Issue/updateAllIssueTasksAdds",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/task_adds/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteAllIssueTasksAdds = createAsyncThunk(
  "Issue/DeleteAllIssueTasksAdds",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/task_adds/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
const FormsAndTemplatesSlice = createSlice({
  name: "FormsAndTemplates",
  initialState: {
    isFormsAndTemplatesLoading: false,
    error: null,
    Model_documentsArray: null,
    AllCompanyTasks: null,
    AllCompanyTasksAdds: null,
  },

  extraReducers: {
    // getModel_documents
    [getModel_documents.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [getModel_documents.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
      state.Model_documentsArray = action.payload.data;
    },
    [getModel_documents.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // addModel_documents
    [addModel_documents.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [addModel_documents.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
      state.Model_documentsArray.push(action.payload.data);
    },
    [addModel_documents.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // updateModel_documents
    [updateModel_documents.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [updateModel_documents.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    [updateModel_documents.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // deleteModel_documents
    [deleteModel_documents.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [deleteModel_documents.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
      state.Model_documentsArray = state.Model_documentsArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [deleteModel_documents.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // getAllIssueTasks

    [getAllIssueTasks.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [getAllIssueTasks.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
      state.AllCompanyTasks = action.payload.data;
    },
    [getAllIssueTasks.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // AddAllIssueTasks
    [AddAllIssueTasks.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [AddAllIssueTasks.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
      state.AllCompanyTasks.push(action.payload.data);
    },
    [AddAllIssueTasks.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // updateAllIssueTasks
    [updateAllIssueTasks.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [updateAllIssueTasks.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    [updateAllIssueTasks.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // DeleteAllIssueTasks
    [DeleteAllIssueTasks.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [DeleteAllIssueTasks.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
      state.AllCompanyTasks = state.AllCompanyTasks.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteAllIssueTasks.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },

    // getAllIssueTasksAdds

    [getAllIssueTasksAdds.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [getAllIssueTasksAdds.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
      state.AllCompanyTasksAdds = action.payload.data;
    },
    [getAllIssueTasksAdds.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // AddAllIssueTasksAdds
    [AddAllIssueTasksAdds.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [AddAllIssueTasksAdds.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
      state.AllCompanyTasksAdds.push(action.payload.data);
    },
    [AddAllIssueTasksAdds.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // updateAllIssueTasksAdds
    [updateAllIssueTasksAdds.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [updateAllIssueTasksAdds.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    [updateAllIssueTasksAdds.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
    // DeleteAllIssueTasksAdds
    [DeleteAllIssueTasksAdds.pending]: (state, action) => {
      state.isFormsAndTemplatesLoading = true;
    },
    [DeleteAllIssueTasksAdds.fulfilled]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
      state.AllCompanyTasksAdds = state.AllCompanyTasksAdds.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteAllIssueTasksAdds.rejected]: (state, action) => {
      state.isFormsAndTemplatesLoading = false;
    },
  },
});

export default FormsAndTemplatesSlice.reducer;
